export default __webpack_public_path__ + "static/media/tanabata.3c0c367e.jpg";